import { Box, Typography, Paper, Button, Divider, Grid } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { Link } from 'react-router-dom';

interface OutcomeSummaryProps {
  title: string;
  processId?: string;
  fields: { label: string; value: string | number | null | undefined }[];
  footerActions?: { label: string; to?: string; onClick?: () => void }[];
}

export const OutcomeSummary = ({ title, processId, fields, footerActions }: OutcomeSummaryProps) => {
  return (
    <Paper sx={{ p: 3, textAlign: 'center' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <CheckCircle sx={{ fontSize: 64, color: 'success.main' }} />
        <Typography variant="h5" fontWeight={700}>
          {title}
        </Typography>
        {processId && (
          <Typography variant="body2" color="text.secondary">
            {processId}
          </Typography>
        )}
      </Box>

      <Divider sx={{ my: 3 }} />

      <Grid container spacing={2} sx={{ textAlign: 'left' }}>
        {fields.filter(f => f.value != null).map((field, i) => (
          <Grid key={i} size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" color="text.secondary">
              {field.label}
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {String(field.value)}
            </Typography>
          </Grid>
        ))}
      </Grid>

      {footerActions && footerActions.length > 0 && (
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 3, flexWrap: 'wrap' }}>
          {footerActions.map((action, i) =>
            action.to ? (
              <Button key={i} component={Link} to={action.to} variant="contained" size="small">
                {action.label}
              </Button>
            ) : (
              <Button key={i} variant="outlined" size="small" onClick={action.onClick}>
                {action.label}
              </Button>
            )
          )}
        </Box>
      )}
    </Paper>
  );
};